import { render, staticRenderFns } from "./IdRecode.vue?vue&type=template&id=4f8fd94f&scoped=true&"
import script from "./IdRecode.vue?vue&type=script&lang=js&"
export * from "./IdRecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fd94f",
  null
  
)

export default component.exports